if (!customElements.get('payment-methods')) {
  class PaymentMethods extends HTMLElement {
    constructor() {
      super();

      this.modalOpener = this.querySelector('[data-modal-opener]');
      this.modal = this.querySelector('[data-modal-payment-methods]');
      this.closeButton = this.querySelector('[data-modal-close]');

      this.initModal();
      this.movePaymentMethods();

      setTimeout(() => {
        this.movePaymentMethods();
      }, 4000);      
    }

    initModal() {
      if (this.modalOpener) {
        this.modalOpener.addEventListener('click', (e) => {
          e.preventDefault();
          this.openModal(this.modal);
        });
      }

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => {
          this.closeModal(this.modal);
        });
      }

      // Close modal when clicking outside
      if (this.modal) {
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) {
            this.closeModal(this.modal);
          }
        });
      }

      // Close modal on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal && this.modal.classList.contains('is-visible')) {
          this.closeModal(this.modal);
        }
      });
    }

    openModal(modal) {
      if (!modal) return;
      modal.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  
    movePaymentMethods() {
      const productForm = document.querySelector('.product-form');
      if (!productForm) return;

      const modalContent = document.querySelector('.modal-payment-methods__content');
      if (!modalContent) return;

      const paymentBlocks = productForm.querySelectorAll('.shopify-app-block');
      
      // Track which payment methods we've found
      const foundMethods = {
        afterpay: false,
        klarna: false
      };

      // Check if blocks already exist in modal content
      const existingBlocks = modalContent.querySelectorAll('.shopify-app-block');
      existingBlocks.forEach(block => {
        const blockId = block.id.toLowerCase();
        if (blockId.includes('afterpay')) foundMethods.afterpay = true;
        if (blockId.includes('klarna')) foundMethods.klarna = true;
      });

      paymentBlocks.forEach(block => {
        const blockId = block.id.toLowerCase();
        
        // Check for afterpay if we haven't found it yet
        if (!foundMethods.afterpay && blockId.includes('afterpay')) {
          const clonedBlock = block.cloneNode(true);
          modalContent.appendChild(clonedBlock);
          block.classList.add('hidden');
          foundMethods.afterpay = true;
        }
        
        // Check for klarna if we haven't found it yet
        if (!foundMethods.klarna && blockId.includes('klarna')) {
          const clonedBlock = block.cloneNode(true);
          modalContent.appendChild(clonedBlock);
          block.classList.add('hidden');
          foundMethods.klarna = true;
        }

        // If we've found both methods, we can stop searching
        if (foundMethods.afterpay && foundMethods.klarna) {
          return;
        }
      });
    }
  }

  customElements.define('payment-methods', PaymentMethods);
} 